class SizeMeasurements {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Buscar todos los contenedores de medidas de tallas en la página
    const sizeContainers = document.querySelectorAll('.size-measurements-container');
    
    sizeContainers.forEach(container => {
      const sizeOptions = container.querySelectorAll('.size-option');
      const images = container.querySelectorAll('.size-measurements-image');
      
      sizeOptions.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSizeChange(option, sizeOptions, images);
        });
      });
    });
  }

  handleSizeChange(selectedOption, allOptions, allImages) {
    const selectedSize = selectedOption.getAttribute('data-size');
    const container = selectedOption.closest('.size-measurements-container');
    
    // Remover clase active de todas las opciones
    allOptions.forEach(option => {
      option.classList.remove('active');
    });
    
    // Agregar clase active a la opción seleccionada
    selectedOption.classList.add('active');
    
    // Ocultar todas las imágenes
    allImages.forEach(image => {
      image.classList.remove('active');
    });
    
    // Mostrar la imagen correspondiente a la talla seleccionada
    const targetImage = container.querySelector(`.size-measurements-image[data-size="${selectedSize}"]`);
    if (targetImage) {
      targetImage.classList.add('active');
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new SizeMeasurements();
});

// También inicializar cuando se cargue contenido dinámicamente (para temas que usan AJAX)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.size-measurements-container')) {
    new SizeMeasurements();
  }
}); 